<template>
  <div id="entries-loading" class="vs-con-loading__container">
    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="top"
        vs-xs="12"
        vs-sm="4"
        vs-lg="4"
      >
        <div id="g1-loading" class="vs-con-loading__container">
          <vs-card style="margin-bottom: -13px">
            <vs-row style="width: 28vw">
              <vs-col vs-w="12" style="padding: 4px">
                <label class="text-sm opacity-75">{{ $t('client') }}</label>
                <v-select
                  v-model="filters.client"
                  :options="clients"
                  class="w-full style"
                  :reduce="(client) => client.ClientId"
                  label="ClientName"
                  @input="loadBar"
                />
              </vs-col>
            </vs-row>
          </vs-card>
          <vs-row>
            <vs-col vs-w="12" style="padding: 4px" >
              <div @click="clickCard('pending')" style="cursor: pointer;">
              <statistics-card-line
                icon="BellIcon"
                icon-right
                :statistic="cards.pending"
                statisticTitle="Pending"
                :hideChart="true"
                color="warning"
              />
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="6" style="padding: 4px">
              <div @click="clickCard('in_process')" style="cursor: pointer;">
              <statistics-card-line
                icon="PlayIcon"
                icon-right
                :statistic="cards.in_process"
                statisticTitle="In Process"
                :hideChart="true"
                color="info"
              />
              </div>
            </vs-col>
            <vs-col vs-w="6" style="padding: 4px">
              <div @click="clickCard('under_review')" style="cursor: pointer;">
              <statistics-card-line
                icon="EyeIcon"
                icon-right
                :statistic="cards.under_review"
                statisticTitle="Under Review"
                :hideChart="true"
                color="info"
              />
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="6" style="padding: 4px">
              <div @click="clickCard('load_order_ready')" style="cursor: pointer;">
              <statistics-card-line
                icon="FlagIcon"
                icon-right
                :statistic="cards.load_order_ready"
                statisticTitle="Load Order Ready"
                :hideChart="true"
                color="success"
              />
              </div>
            </vs-col>
            <vs-col vs-w="6" style="padding: 4px">
              <div @click="clickCard('shipped')" style="cursor: pointer;">
              <statistics-card-line
                icon="TruckIcon"
                icon-right
                :statistic="cards.shipped"
                statisticTitle="Shipped"
                :hideChart="true"
                color="success"
              />
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-xs="12"
        vs-sm="4"
        vs-lg="4"
      >
        <vs-card class="mx-2 mb-3 custom-card-h">
          <div id="g2-loading" class="vs-con-loading__container">
            <div slot="header">
              <vs-row :style="{ borderBottom: '#bec0c2 solid 2px' }">
                <vs-col vs-w="6">
                  <h4 @click="clickTitle" class="donutTitle">
                    {{ $t('warehouse_aging') | title(' ') }}
                  </h4>
                </vs-col>
                <vs-col
                  vs-offset="4"
                  vs-w="1"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                >
                  <vx-tooltip delay="0.5s" text="Pallets" tooltipPosition="top">
                    <feather-icon
                      icon="LayersIcon"
                      :style="{
                        color:
                          lastIconClicked == 'pallets' ? '#ba0000' : '#5d6063',
                      }"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="clickPalletsIcon()"
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-col
                  vs-w="1"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                >
                  <vx-tooltip delay="0.5s" text="Parcels" tooltipPosition="top">
                    <feather-icon
                      icon="BoxIcon"
                      :style="{
                        color:
                          lastIconClicked == 'pallets' ? '#5d6063' : '#ba0000',
                      }"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="clickParcelsIcon()"
                    />
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </div>
            <donut-chart
              :chartId="'entries-donut'"
              :height="'300'"
              :centerLabel="' '"
              :valueFontSize="'16px'"
              :series="seriesDonut"
              @clickDonutSection="clickPalletsDonut"
            />
          </div>
        </vs-card>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-xs="12"
        vs-sm="4"
        vs-lg="4"
      >
        <vs-card class="mx-2 mb-3 custom-card-h">
          <div id="g3-loading" class="vs-con-loading__container">
            <div slot="header">
              <vs-row :style="{ borderBottom: '#bec0c2 solid 2px' }">
                <vs-col vs-w="10">
                  <h4 :style="{ padding: '10px' }">
                    {{ $t('pallets_in_warehouse_by_client') | title(' ') }}
                  </h4>
                </vs-col>
              </vs-row>
            </div>
            <donut-chart
              :chartId="'warehouse-donut'"
              :height="'300'"
              :series="seriesDonut"
              class="line-down"
              :centerFontSize="'26px'"
              :valueFontSize="'20px'"
              @clickDonutSection="clickWarehouseDonut"
            />
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col>
        <vs-card>
          <div id="entry-table-loading" class="vs-con-loading__container">
            <entry-filter />
            <entry-table
              :data="list"
              @loadMore="loadMore"
              @search="handleSearch"
              @sort="sort"
            />
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import AddButton from '@/views/components/buttons/AddButton'
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import EntryTable from './components/EntryTable'
import StackedColumns from './components/StackedColumnsChart.vue'
import vSelect from 'vue-select'
import EntryFilter from './components/EntryFilter'
import loading from '@/mixins/Loading'
import moduleEntry from '@/store/entry/moduleEntry'

import client from '@/http/requests/client'
import entry from '@/http/requests/entry'

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
  components: {
    AddButton,
    DonutChart,
    EntryTable,
    StackedColumns,
    vSelect,
    EntryFilter,
    StatisticsCardLine
  },
  computed: {
    list() {
      return this.$store.state.entry.entryList
    },
    isLoading() {
      return this.loading.data || this.loading.clients || this.loading.bar_plot || this.loading.warehouse_donut
    },
  },
  created() {
    if (!moduleEntry.isRegistered) {
      this.$store.registerModule('entry', moduleEntry)
      moduleEntry.isRegistered = true
    }
  },
  data: () => ({
    lastPage: '',
    params: {
      filter: 'pallets',
      status: ['1','2','4','8']
    },
    search: '',
    page: 1,
    seriesDonut: [0],
    filters: {
      client: ''
    },
    clients: [],
    loading: {
      data: false,
      clients: false,
      bar_plot: false,
      warehouse_donut: false
    },
    warehouse: {
      series: [0],
      labels: [''],
      colors: ['#123456']
    },
    lastIconClicked: 'pallets',
    loadWarehouse: true,
    cards: {
      in_process: 0,
      pending: 0,
      under_review: 0,
      load_order_ready: 0,
      documents_sent: 0,
      review_completed: 0,
      shipped: 0
    }
  }),
  methods: {
    getData() {
      this.loading.data = true
      let data = Object.assign({}, this.params)
      data.page = this.page
      data.search = this.search
      this.$store
        .dispatch('entry/fetchEntryList', data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.loading.data = false
        })
        .catch((err) => {
          this.loading.data = false
        })
    },
    getClients() {
      this.loading.clients = true
      client.list().then((res) => {
        this.clients = res.data.clients
        this.filters.client = this.clients[0].ClientId
        this.loadBar()
        this.loading.clients = false
      })
        .catch(err => {
          this.loading.clients = false
        })
    },
    loadBar() {
      this.loading.bar_plot = true
      entry.getBarPlotDate(this.filters.client).then(res => {
        let cards = res.data.data
        this.cards = {
          in_process: 0,
          pending: 0,
          under_review: 0,
          load_order_ready: 0,
          documents_sent: 0,
          review_completed: 0,
          shipped: 0
        }
        this.params.client_name=null
        this.params.client=[this.filters.client]
        this.params.status=['1','2','4','8']
        this.params.filter=null
        this.getData()
        cards.forEach(item => {
          switch (item.name) {
            case 'Load Order Ready':
              this.cards.load_order_ready = Number(item.total)
              break;
            case 'Under Review':
              this.cards.under_review = Number(item.total)
              break;
            case 'Pending':
              this.cards.pending = Number(item.total)
              break;
            case 'In Process':
              this.cards.in_process = Number(item.total)
              break;
            case 'Documents Sent':
              this.cards.documents_sent = Number(item.total)
              break;
            case 'Review Completed':
              this.cards.review_completed = Number(item.total)
              break;
            case 'Shipped':
              this.cards.shipped = Number(item.total)
              break;
            default:
              break;
          }
        });
        this.loading.bar_plot = false
      }).catch(err => {
        console.log(err)
        this.loading.bar_plot = false
      })
    },
    loadEntriesDonut() {
      entry.averageAgingDonut(this.params.filter).then(res => {
        let title = Number(res.data.data).toFixed(2)
        ApexCharts.exec(
          'entries-donut',
          'updateOptions',
          {
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    total: {
                      label: title,
                      formatter: function (w) {
                        return '(Average days Aging)'
                      }
                    }
                  }
                }
              }
            }
          },
          false, true
        )
      })
      entry.getFirstDonut(this.params.filter).then(res => {
        let arrayColors = []
        let labels = []
        let series = [0]
        let entries = res.data.data
        entries.forEach((item, index) => {
          series[index] = Number(item.total)
          labels[index] = item.ShortName
          arrayColors[index] = item.color
        })
        //this.seriesDonut=series
        this.warehouse.series = series
        this.warehouse.labels = labels
        this.warehouse.colors = arrayColors
        if (this.loadWarehouse == true) {
          this.loadWarehouse = false
          this.loadWarehouseDonut()
        }
        ApexCharts.exec(
          'entries-donut',
          'updateOptions',
          {
            fill: {
              colors: arrayColors
            },
            legend: {
              markers: {
                fillColors: arrayColors
              }
            },
            labels: labels,
            series: series
          },
          false, true
        )
      })
    },
    loadWarehouseDonut() {
      this.loading.warehouse_donut = true
      entry.warehouseCapacityDonut().then(res => {
        let occupied_asigned_clients = Number(res.data.occupied_asigned_clients).toFixed(2)
        let occupied_total = Number(res.data.occupied_all_clients).toFixed(2)
        ApexCharts.exec(
          'warehouse-donut',
          'updateOptions',
          {
            fill: {
              colors: this.warehouse.colors
            },
            legend: {
              markers: {
                fillColors: this.warehouse.colors
              }
            },
            labels: this.warehouse.labels,
            series: this.warehouse.series,
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    total: {
                      label: occupied_asigned_clients + ' %',
                      color: '#009c22',
                      formatter: function (w) {
                        return occupied_total + ' % Full'
                      }
                    },
                    value: {
                      color: '#bd2900'
                    }
                  }
                }
              }
            }
          },
          false, true
        )
        this.loading.warehouse_donut = false
      }).catch(err => {
        console.log(err)
        this.loading.warehouse_donut = false
      })
    },
    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },
    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },
    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getData()
    },
    clickPalletsDonut(config) {
      this.params.status=['1','2','4','8']
      this.params.client = null
      this.params.client_name = config.w.config.labels[config.dataPointIndex]
      this.params.filter = this.lastIconClicked
      this.page = 1
      this.getData()
    },
    clickWarehouseDonut(config) {
      this.params.client = null
      this.params.client_name = config.w.config.labels[config.dataPointIndex]
      this.params.filter = 'pallets'
      this.params.status = ['1','2','4','8']
      this.page = 1
      this.getData()
    },
    clickPalletsIcon() {
      if (this.params.filter == 'pallets') return //La info ya se muestra en dona
      this.params.filter = 'pallets'
      this.lastIconClicked = 'pallets'
      this.params.status = ['1','2','4','8']
      this.page = 1
      this.loadEntriesDonut()
      this.getData()
    },
    clickParcelsIcon() {
      if (this.params.filter == 'parcels') return //La info ya se muestra en dona
      this.params.filter = 'parcels'
      this.lastIconClicked = 'parcels'
      this.params.status = ['1','2','4','8']
      this.page = 1
      this.loadEntriesDonut()
      this.getData()
    },
    clickTitle() {
      this.params.client_name = null
      this.params.filter =  this.lastIconClicked
      this.params.status = ['1','2','4','8']
      this.params.client = null
      this.page = 1
      this.getData()
    },
    clickCard(title){
      this.params.client=[this.filters.client]
      this.params.client_name = null
      this.params.filter=null
      switch (title) {
        case 'in_process':
          this.params.status=['8']
          break;
        case 'under_review':
          this.params.status=['2']
          break;
        case 'load_order_ready':
          this.params.status=['4']
          break;
        case 'shipped':
          this.params.status=['5']
          break;
        default:
          this.params.status=['1']
          break;
      }
      this.page=1
      this.getData()
    },
  },
  mounted() {
      this.getClients()
      this.loadEntriesDonut()
  },
  mixins: [loading],
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`entries-loading`)
      } else {
        this.closeLoading(`entries-loading`)
      }
    },
  }
}
</script>

<style>
.donutTitle {
  cursor: pointer;
  padding: 10px;
}

h4.donutTitle:hover {
  color: #bc1300;
}

.custom-card-h {
  height: 340px;
}
.style .vs__dropdown-toggle,
.style .vs__dropdown-menu {
  max-height: 200px;
}

</style>
